import {
  FETCH_PROTECTION_TIERS_REQUEST,
  FETCH_PROTECTION_TIERS_SUCCESS,
  FETCH_PROTECTION_TIERS_FAILURE,
  CREATE_PROTECTION_TIER_REQUEST,
  CREATE_PROTECTION_TIER_SUCCESS,
  CREATE_PROTECTION_TIER_FAILURE,
  UPDATE_PROTECTION_TIER_REQUEST,
  UPDATE_PROTECTION_TIER_SUCCESS,
  UPDATE_PROTECTION_TIER_FAILURE,
  DELETE_PROTECTION_TIER_REQUEST,
  DELETE_PROTECTION_TIER_SUCCESS,
  DELETE_PROTECTION_TIER_FAILURE,
} from "../actions/types";

const initialState = {
  protectionTiers: [],
  loading: false,
  error: null,
  message: "",
};

const protectionTierReducer = (state = initialState, action) => {
  switch (action.type) {
    // Requests
    case FETCH_PROTECTION_TIERS_REQUEST:
    case CREATE_PROTECTION_TIER_REQUEST:
    case UPDATE_PROTECTION_TIER_REQUEST:
    case DELETE_PROTECTION_TIER_REQUEST:
      return { ...state, loading: true, error: null };

    // Fetch success
    case FETCH_PROTECTION_TIERS_SUCCESS:
      return {
        ...state,
        loading: false,
        protectionTiers: action.payload,
        message: "Protection tiers loaded successfully",
      };

    // Create success
    case CREATE_PROTECTION_TIER_SUCCESS:
      return {
        ...state,
        loading: false,
        protectionTiers: [...state.protectionTiers, action.payload],
        message: "Protection tier created successfully",
      };

    // Update success
    case UPDATE_PROTECTION_TIER_SUCCESS:
      return {
        ...state,
        loading: false,
        protectionTiers: state.protectionTiers.map((tier) =>
          tier.id === action.payload.id ? action.payload : tier
        ),
        message: "Protection tier updated successfully",
      };

    // Delete success
    case DELETE_PROTECTION_TIER_SUCCESS:
      return {
        ...state,
        loading: false,
        protectionTiers: state.protectionTiers.filter((tier) => tier.id !== action.payload),
        message: "Protection tier deleted successfully",
      };

    // Failures
    case FETCH_PROTECTION_TIERS_FAILURE:
    case CREATE_PROTECTION_TIER_FAILURE:
    case UPDATE_PROTECTION_TIER_FAILURE:
    case DELETE_PROTECTION_TIER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default protectionTierReducer;